export default __webpack_public_path__ + "static/media/bg-dark-blur-large.3312a04c.png";